import { css, jsx } from '@emotion/core';
import React, { useEffect, useState } from 'react';

import Link from '@/src/shared/components/Link';
import Table from '@/src/shared/components/Table';
import { colors } from '@/styles';
import request from '@/utils/axios';

const style = {
  name: css`
    color: ${colors.secondaryBlue};
    font-weight: bolder;
  `,
  sorterText: css`
    font-weight: bolder;
    margin-bottom: 0px;
  `,
};
const CommitteeSort = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchData = async type => {
    const result = await request({
      url: `profile/staffprofiles?type=${type}`,
    });
    const {
      data: { Profiles },
    } = result;
    setData(Profiles);
    setLoading(false);
  };

  useEffect(() => {
    fetchData('committee');
  }, []);

  const columns = [
    {
      title: 'Committee',
      dataIndex: 'Committee',
      key: 'Committee',
      render: (text, record) => {
        return (
          <Link
            css={style.sorterText}
            href="/policy/committees/[slug]"
            as={`/policy/committees/${record.CommitteeId}`}
          >
            {text}
          </Link>
        );
      },
      width: '250px',
    },
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
      render: (text, record) => {
        return (
          <Link anchor css={style.name} href={`mailto:${record.EmailAddress}`}>
            {text}
          </Link>
        );
      },
      width: '250px',
    },
    {
      title: 'Phone',
      dataIndex: 'Phone',
      key: 'Phone',
      render: text => {
        return (
          <Link anchor href={`tel:${text}`}>
            {text}
          </Link>
        );
      },
      width: '180px',
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      rowKey={(record, i) => {
        return `${record.PersonId}-${i + 1}`;
      }}
      showHeader={false}
      pagination={false}
      scroll={{ x: 680 }}
      css={css`
        .ant-table-row-cell-break-word {
          white-space: normal !important;
        }
      `}
    />
  );
};

export default CommitteeSort;
